import { placeCategoryToMapMarkerIcon, isMobileDevice, isiOS, detectBrowser } from "../utils/Utils";


class BillboardLocation{
    constructor(elementId, lat, lng, places){
        this.main = document.getElementById(elementId);
        this.browserInfo = detectBrowser();

        this._mapLinkBtn = this.main.querySelector('.map_link_btn');
        
        this._map = null;

        this._coords = {lat: lat, lng: lng};
        this._places = places;
        
        if(isMobileDevice()){
            if(isiOS()){
                if(this.browserInfo.value == 'chrome_ios'){
                    this._mapLinkBtn.href = `https://maps.google.com/maps?q=${this._coords.lat},${this._coords.lng}`;
                }else{
                    this._mapLinkBtn.href = `https://maps.apple.com/maps?q=${this._coords.lat},${this._coords.lng}`;
                }
            }else{
                this._mapLinkBtn.href = `geo:${this._coords.lat},${this._coords.lng}?q=${this._coords.lat},${this._coords.lng}`;
            }
        } else if (this._mapLinkBtn.getAttribute('href') === '#') {
            this._mapLinkBtn.href = `https://maps.google.com/maps?q=${this._coords.lat},${this._coords.lng}`;
        }

        this._placeInfoWindow = null;

        this._isGoogleMapsReady = false;

        if (typeof google === 'object' && typeof google.maps === 'object') {
            this._onGoogleMapsReady();
        } else {
            window.onGoogleMapsReady = this._onGoogleMapsReady.bind(this);

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = `${BASE_URL}api/maps?callback=onGoogleMapsReady`;
            document.body.appendChild(script);
        }
    }

    _onGoogleMapsReady(){
        this._isGoogleMapsReady = true;

        let position = new google.maps.LatLng(this._coords.lat, this._coords.lng); 

        this._map = new google.maps.Map(this.main.querySelector('.map'), {
            center: position,
            zoom: 16,
            minZoom:7,
            maxZoom:17,
            zoomControlOptions:{
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            gestureHandling: "greedy",
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: true,
            fullscreenControl: false,
            clickableIcons: false,
            styles: [
                {
                    "featureType": "administrative.country",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });
        
        let billboardMarkerIcon = new google.maps.MarkerImage(
            `${IMG_PATH}ui/map/markers/marker-logo.svg`, 
            null, 
            null, 
            null, 
            new google.maps.Size(54, 54)
        );

        let billboardMarker = new google.maps.Marker({
            position: position,
            map: this._map,
            icon: billboardMarkerIcon,
            zIndex: 2000
        });
    
        this._places.forEach((place)=>{
            
            let placeIcon = placeCategoryToMapMarkerIcon(place.category.id);
            
            let placeMarker = new google.maps.Marker({
                position: new google.maps.LatLng(place.lat, place.lng),
                name: place.name,
                map: this._map,
                icon: placeIcon,
                optimized: false                    
            });

            if(isMobileDevice()){
                google.maps.event.addListener(placeMarker, 'click', ()=>{
                    event.stopPropagation();
                    event.preventDefault();
                    this._onMouseOverPlaceMarker(placeMarker);
                    
                });
                
                google.maps.event.addListener(this._map, 'click', ()=>{
                    this._onMouseOutPlaceMarker();
                })
                
                
            }else{
                google.maps.event.addListener(placeMarker, 'mouseover', (e)=>{
                    this._onMouseOverPlaceMarker(placeMarker);
                });
                
                google.maps.event.addListener(placeMarker, 'mouseout', (e)=>{
                    this._onMouseOutPlaceMarker();
                });
            }
        });

        this._placeInfoWindow = new google.maps.InfoWindow();
        
        google.maps.event.addListener(this._placeInfoWindow, 'domready', this._onPlaceInfoWindowDomReady.bind(this)); 
    }

    _onMouseOverPlaceMarker(marker){
        let content = `<div class="tooltip-map tooltip-map--place">${marker.name}</div>`;
        this._placeInfoWindow.setContent(content);
        this._placeInfoWindow.open(this._map, marker);
    }

    _onMouseOutPlaceMarker(){
        this._placeInfoWindow.close();
    }

    _onPlaceInfoWindowDomReady(e){
        try{
            this._placeInfoWindow.getContent().parentElement.parentElement.querySelector('.gm-ui-hover-effect').style.display = 'none';
        }catch(e){

        }
    }
}

export default BillboardLocation;